import GeometryPlugin from './plugins/geometry'
import ScaledApplicationPlugin from './plugins/scaled-application'
import Sortable from 'sortablejs'

Sortable.mount([new GeometryPlugin(), new ScaledApplicationPlugin()])
